var React = require('react');

function IconResponded (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.27238 3.32899H5.72757V0.5L0.599976 4.8907L5.72757 9.275V6.44601H7.42609C10.8295 6.44601 11.4 9.275 11.4 9.275C11.3743 5.87637 9.88733 3.59141 6.27238 3.32899Z"}));
}

IconResponded.defaultProps = {"width":"12","height":"10","viewBox":"0 0 12 10","fill":"currentColor"};

module.exports = IconResponded;

IconResponded.default = IconResponded;
